import React, {useEffect} from "react";
import { Alert, Button, Typography  } from "@mui/material";
import { StyledTextField, ConfirmationContainer, FormContainer } from "../styles";
import { useNavigate } from "react-router-dom";
import {useCustomer} from "context/customer/customerContext";

/**
 *
 */
function CustomerDetails() {
  const navigate = useNavigate();
  const {customerDetails, fetchCustomerDetails} = useCustomer();
  const {customerName, city, brand, model, state, street1, street2, vin, year, zipCode, loan} = customerDetails;

  const handleConfirmDetails = () => {
    const {isProblemTitle, isAccountDelinquent} = customerDetails;
    if (isProblemTitle === true) {
      navigate("/customer/error/title_issue");
      return;
    }

    if (isAccountDelinquent === true) {
      navigate("/customer/error/delinquent_account");
      return;
    }

    navigate("/customer/introduction");
  };

  useEffect(() => {
    fetchCustomerDetails().then(res => {
      if (!res.success) {
        navigate("/");
      }
    });
  }, []);

  return (
    <ConfirmationContainer>
      <FormContainer elevation={3}>
        <Typography variant="h5" gutterBottom>
        Are these details correct?
        </Typography>
        <Alert
          severity="info"
          variant="outlined"
          sx={{ borderRadius: "8px", mt: 3, mb: 3 }} // Adjust if necessary
        >
          <Typography variant="subtitle2" gutterBottom>
          If your details are incorrect, contact HDFS at 800-717-3450 before proceeding.
          </Typography>
        </Alert>

        <Typography variant="subtitle1" gutterBottom>
        Personal Details
        </Typography>
        <StyledTextField defaultValue="" fullWidth label="Full Name" variant="outlined" value={customerName || ""} disabled />
        <StyledTextField fullWidth label="Address Line 1" variant="outlined" value={street1 || ""} disabled />
        <StyledTextField fullWidth label="Address Line 2" variant="outlined" value={street2 || ""} disabled />
        <StyledTextField fullWidth label="City" variant="outlined" value={city || ""} disabled />
        <StyledTextField fullWidth label="State" variant="outlined" value={state || ""} disabled />
        <StyledTextField fullWidth label="Zip Code" variant="outlined" value={zipCode || ""} disabled />
        <StyledTextField fullWidth label="Loan ID" value={loan || ""} variant="outlined" disabled />

        <Typography variant="subtitle1" gutterBottom style={{ marginTop: "20px" }}>
        Vehicle Details
        </Typography>
        <StyledTextField fullWidth label="Year" value={year || ""} variant="outlined" disabled />
        <StyledTextField fullWidth label="Brand" value={brand || ""} variant="outlined" disabled />
        <StyledTextField fullWidth label="Model" value={model || ""} variant="outlined" disabled />
        <StyledTextField fullWidth label="VIN" value={vin || ""} variant="outlined" disabled />

        <Button variant="contained" color="secondary" fullWidth style={{ marginTop: "20px" }} onClick={handleConfirmDetails}>
        Confirm Details
        </Button>
      </FormContainer>
    </ConfirmationContainer>
  );
}

export default CustomerDetails;
